import React, { lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import NewsletterPopup from "./components/NewsletterPopup";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import UniversPage from "./pages/UniversPage";
import SubcategoriesPage from "./pages/SubcategoriesPage";
import CategoriesPage from "./pages/CategoriesPage";
import ServicesPage from "./pages/ServicesPage";
import FAQPage from "./pages/FAQPage";
import ContactPage from "./pages/ContactPage";
import ActualitesPage from "./pages/ActualitesPage";
import ArticlePage from "./pages/ArticlePage";
import ZonesLivraisonPage from "./pages/ZonesLivraisonPage";
import CityLandingPage from "./pages/CityLandingPage";
import ZoneLandingPage from "./pages/ZoneLandingPage";
import MentionsLegalesPage from "./pages/MentionsLegalesPage";
import ConditionsGeneralesPage from "./pages/ConditionsGeneralesPage";
import AvisClientsPage from "./pages/AvisClientsPage";
import GuidesPage from "./pages/GuidesPage";
import GuidePage from "./pages/GuidePage";
import { SeoProvider, SeoRouteGuard, useIsNotFound } from "./seo/SeoProvider";
import NotFoundPage from "./pages/NotFoundPage";
const ReservationPage = lazy(() => import("./pages/ReservationPage"));
const CataloguePDFPage = lazy(() => import("./pages/CataloguePDFPage"));
const AdminPage = lazy(() => import("./pages/AdminPage"));
const lazyPage = element => <Suspense fallback={<div data-testid="page-loading" className="min-h-screen" />}>{element}</Suspense>;
import {AppErrorBoundary} from "./components/AppErrorBoundary";

function MainContent() {
  const isNotFound = useIsNotFound();
  if (isNotFound) return <NotFoundPage />;
  return (
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/univers" element={<UniversPage />} />
                  <Route path="/univers/:slug" element={<SubcategoriesPage />} />
                  <Route path="/categories" element={<CategoriesPage />} />
                  <Route path="/equipements/:slug" element={<CategoriesPage />} />
                  <Route path="/equipements/:slug/:subcategorySlug" element={<CategoriesPage />} />
                  <Route path="/reservation/:productId" element={lazyPage(<ReservationPage />)} />
                  <Route path="/location/:slug" element={lazyPage(<ReservationPage />)} />
                  <Route path="/services" element={<ServicesPage />} />
                  <Route path="/zones-livraison" element={<ZonesLivraisonPage />} />
                  <Route path="/location-materiel/:city" element={<CityLandingPage />} />
                  <Route path="/location-materiel-zone/:zone" element={<ZoneLandingPage />} />
                  <Route path="/faq" element={<FAQPage />} />
                  <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
                  <Route path="/conditions-generales-location" element={<ConditionsGeneralesPage />} />
                  <Route path="/avis-clients" element={<AvisClientsPage />} />
                  <Route path="/guides" element={<GuidesPage />} />
                  <Route path="/guides/:slug" element={<GuidePage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/actualites" element={<ActualitesPage />} />
                  <Route path="/actualites/:slug" element={<ArticlePage />} />
                  <Route path="*" element={<NotFoundPage />} />
                </Routes>
  );
}

export function AppContent() {
  return (
      <>
        <ScrollToTop />
        <SeoProvider><SeoRouteGuard>
        <Routes>
          <Route path="/catalogue-pdf" element={lazyPage(<CataloguePDFPage />)} />
          <Route path="/admin" element={lazyPage(<AdminPage />)} />
          
          {/* Redirections anciennes URLs Google vers nouvelles URLs */}
          <Route path="/jardinage" element={<Navigate to="/univers/jardinage-motoculture" replace />} />
          <Route path="/Jardinage" element={<Navigate to="/univers/jardinage-motoculture" replace />} />
          <Route path="/evenementiel" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/Evenementiel" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/Evènementiel" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/bricolage" element={<Navigate to="/univers/bricolage-travaux" replace />} />
          <Route path="/Bricolage" element={<Navigate to="/univers/bricolage-travaux" replace />} />
          <Route path="/les-indispensables" element={<Navigate to="/univers/nettoyage-logement" replace />} />
          <Route path="/Les-indispensables" element={<Navigate to="/univers/nettoyage-logement" replace />} />
          <Route path="/nettoyage" element={<Navigate to="/univers/nettoyage-logement" replace />} />
          <Route path="/Nettoyage" element={<Navigate to="/univers/nettoyage-logement" replace />} />
          <Route path="/Mobilier" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/mobilier" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/Pack soirée" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/pack-soiree" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          {/* Anciennes catégories spécifiques */}
          <Route path="/travaux" element={<Navigate to="/univers/bricolage-travaux" replace />} />
          <Route path="/Travaux" element={<Navigate to="/univers/bricolage-travaux" replace />} />
          <Route path="/motoculture" element={<Navigate to="/univers/jardinage-motoculture" replace />} />
          <Route path="/logement" element={<Navigate to="/univers/nettoyage-logement" replace />} />
          <Route path="/loisirs" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/barnum" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          <Route path="/Barnum" element={<Navigate to="/univers/evenementiel-barnum" replace />} />
          
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <MainContent />
              </main>
              <Footer />
              <AppErrorBoundary fallback={null}><NewsletterPopup /></AppErrorBoundary>
            </>
          } />
        </Routes>
        </SeoRouteGuard></SeoProvider>
      </>
  );
}

function App() {
  return (
    <div className="App">
      <AppErrorBoundary><BrowserRouter><AppContent /></BrowserRouter></AppErrorBoundary>
    </div>
  );
}

export default App;
